<template>
    <b-modal id="editModal" ref="modal" title="Edit Association" v-model="show" @ok="handleSubmit" @hide="close" @shown="focusNameInput">

        <div class="form-group">
            <label>Association Name</label>
            <div class="position-relative">
                <input type="text" ref="nameInput" name="name" v-validate="{required: true}" class="form-control" v-model="update.name">
                <div class="invalid-feedback" v-if="errors.has('name')">{{ errors.first('name') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <div class="form-group">
            <label>Managed Crop Type</label>
            <div class="position-relative">
                <vue-select :options="cropTypes" track-by="id" label="name" v-model="update.cropType"></vue-select>
                <div class="invalid-feedback" v-if="errors.has('cropType')">{{ errors.first('cropType') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <template slot="modal-footer">
            <button class="btn btn-link text-danger mr-auto" @click="handleDelete" v-if="!association.deleted_at">
                Disable
            </button>
            <button class="btn btn-link text-danger mr-auto" @click="handleRestore" v-if="association.deleted_at">
                Restore
            </button>
            <button class="btn btn-secondary" @click="close">
                Cancel
            </button>
            <button class="btn btn-primary" :disabled="okDisabled" @click="handleSubmit">
                Save
            </button>
        </template>
    </b-modal>
</template>


<script>
import deleteAssociationMutation from '@views/Associations/EditModal/mutationDeleteAssociation.graphql';
import restoreAssociationMutation from '@views/Associations/EditModal/mutationRestoreAssociation.graphql';
import updateAssociationMutation from '@views/Associations/EditModal/mutationUpdateAssociation.graphql';
import listCropTypesQuery from '@views/Associations/EditModal/queryListCropTypes.graphql';

export default {
  name: 'edit-modal',
  apollo: {
    allCropTypes: {
      query: listCropTypesQuery,
      update: data => data.filterCropTypes.data,
      variables() {
        return {
          input: {
            limit: 1000,
          },
        };
      },
    },
  },
  props: {
    association: {
      type: Object,
      required: true,
    },
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      update: {
        name: this.association.name,
        cropType: this.association.cropType,
      },
      show: true,
      allCropTypes: [],
      loading: 0,
    };
  },
  computed: {
    cropTypes() {
      const list = this.allCropTypes.filter(
        cropType => !cropType.association,
      );
      if (this.association.cropType) {
        list.push(this.association.cropType);
      }
      return list.sort((a, b) => a.name.localeCompare(b.name));
    },
    okDisabled() {
      return this.update.name.length === 0;
    },
  },
  methods: {
    handleSubmit() {
      if (this.okDisabled) {
        return false;
      }
      this.errors.remove('global');
      this.$validator.validateAll().then(validationWasSuccessful => {
        if (!validationWasSuccessful) {
          return;
        }

        const optimisticResponse = {
          __typename: 'Mutation',
          updateAssociation: {
            ...this.association,
            ...this.update,
          },
        };

        this.$apollo
          .mutate({
            mutation: updateAssociationMutation,
            variables: {
              input: {
                id: this.association.id,
                name: this.update.name,
                crop_type_id: this.update.cropType.id,
              },
            },
            optimisticResponse,
          })
          .then(() => {
            this.$notifySuccess('Association updated!');
            this.close();
          })
          .catch(err => {
            this.$mapGraphQLError(err);
          })
          .catch(err => {
            console.error(err);
            this.$notifyFailure(
              'Unfortunately, we were unable to do that!',
            );
          });
      });
    },
    handleDelete() {
      const optimisticResponse = {
        __typename: 'Mutation',
        deleteAssociation: {
          id: this.association.id,
          ...this.association,
          cropType: [],
          deleted_at: '1970-01-01 00:00:00',
        },
      };

      if (this.association.cropType) {
        optimisticResponse.deleteAssociation.cropType.push({
          ...this.association.cropType,
          association: null,
        });
      }

      this.$apollo
        .mutate({
          mutation: deleteAssociationMutation,
          variables: {
            input: {
              id: this.association.id,
            },
          },
          optimisticResponse,
        })
        .then(() => {
          this.$notifySuccess('Association disabled!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure(
            'Unfortunately, we were unable to do that!',
          );
        });
    },
    handleRestore() {
      this.$apollo
        .mutate({
          mutation: restoreAssociationMutation,
          variables: {
            input: {
              id: this.association.id,
            },
          },
          optimisticResponse: {
            __typename: 'Mutation',
            restoreAssociation: {
              ...this.association,
              deleted_at: null,
              cropType: {
                ...this.association.cropType,
                association: {
                  ...this.association,
                  deleted_at: null,
                },
              },
            },
          },
        })
        .then(() => {
          this.$notifySuccess('Association restored!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure(
            'Unfortunately, we were unable to do that!',
          );
        });
    },
    focusNameInput() {
      this.$refs.nameInput.focus();
    },
  },
};
</script>
